import { SeverityItem } from 'aos-ds/src/primitives/severityitem/SeverityItem'
import React from 'react'
import { View } from 'react-native'

import { twMerge } from '../../tailwind/merge'
import type { PunctualityKpiWindow } from '../punctuality-kpi-direction'
import { TrendMeasure } from '../trend-measure'

export type PunctualityMobileTodayRowProps = {
    today: PunctualityKpiWindow
    emptyValueText: string
    className?: string
    testID?: string
}

/**
 * Figma `Widget/Punctuality/Mobile/TodayRow` (19908:474096): the Today value of
 * the mobile tile — its status dot and the small measure with the caption
 * inline, `small-compact/xs` apart. The measure fills the row; its 44px height
 * is the measure's own.
 */
export const PunctualityMobileTodayRow = ({
    today,
    emptyValueText,
    className,
    testID = 'punctuality-mobile-today-row',
}: PunctualityMobileTodayRowProps) => (
    <View
        className={twMerge('w-full min-w-0 flex-row items-center gap-xs', className)}
        testID={testID}
    >
        <SeverityItem variant={today.status} size='small' className='shrink-0' />
        <TrendMeasure
            size='small'
            labelPosition='inline'
            value={today.value}
            unit={today.unit}
            label={today.label}
            emptyValueText={emptyValueText}
            trend={today.trend}
            className='min-w-0 flex-1 items-baseline'
        />
    </View>
)

PunctualityMobileTodayRow.displayName = 'PunctualityMobileTodayRow'
